import React, { Component, Fragment } from 'react';
import classes from './Checkout.css';
import CheckoutSummary from '../../components/CheckoutSummary/CheckoutSummary';
import CheckoutForm from './CheckoutForm/CheckoutForm';
import Modal from '../../components/UI/Modal/Modal'
import Button from '../../components/UI/Button/Button';
import axios from '../../axios-orders';
import Spinner from '../../components/UI/Spinner/Spinner';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import * as actionCreators from '../../store/actions/index';

import { connect } from 'react-redux';

class Checkout extends Component {
  componentDidMount() {
    if (!this.props.ingredients) {
      setTimeout(() => {
        if (this.props.token) {
          this.props.GetBurgerData(this.props.token, this.props.userId);
        } else {
          this.props.history.push('/')
        }
      }, 0)
    }
    if (!this.props.orders) {
      setTimeout(() => {
        if (this.props.token) {
          this.props.GetOrders(this.props.token, this.props.userId);
        } else {
          this.props.history.push('/')
        }
      }, 0)
    }
    if (!this.props.nextOrderID) {
      setTimeout(() => {
        if (this.props.token) {
          this.props.GetNextID(this.props.token, this.props.userId);
        } else {
          this.props.history.push('/')
        }
      }, 0)
    }
    if (this.props.ingredients && this.props.redirectLocation === '/checkout') {
      this.props.SetServerBurgerData(this.props.token, this.props.userId, this.props.ingredients)
    }
  }

  componentDidUpdate() {
    // if no ingredients, redirect to the build page
    if ((this.props.ingredients && Object.values(this.props.ingredients).reduce((sum, added) => {
      return sum + added;
    }) === 0) || (!this.props.token)) {
      this.props.history.push('/build');
    }

    // if a token is present, but the expiration date has past, log the user out.
    if (localStorage.getItem('expirationDate') && (new Date(localStorage.getItem('expirationDate')).getTime() <= new Date().getTime())) {
      this.props.Logout();
    }
  }

  componentWillUnmount() {
    if (this.props.error) {
      this.props.ClearPageError();
    }
    if (this.props.redirectLocation !== '/build') {
      this.props.SetLoginRedirect('/build');
    }
  }

  dismissSuccessMessage = () => {
    this.props.ResetOrder()
    this.props.ToggleModal();
  }

  render() {
    let checkoutSummary = <Spinner center={true} />
    let checkoutForm = null;

    if (this.props.ingredients) {
      checkoutSummary = <CheckoutSummary ingredients={this.props.ingredients} total={this.props.total} prices={this.props.prices} />;
      checkoutForm = <CheckoutForm submitOrder={(formData) => { this.props.SubmitOrder(formData, this.props.token, this.props.userId) }} />
    }





    return (<div className={classes.Checkout}>
      <Modal show={this.props.showModal}
        clicked={() => { this.dismissSuccessMessage() }}>
        <Fragment>
          <h2>Success!</h2>
          <br />
          <p>
            Your order was received.  You can review your order from the past orders tab.</p>
          <Button btnType={'Success'} clicked={() => { this.dismissSuccessMessage() }}>
            Okay
    </Button>
        </Fragment>
      </Modal>
      {checkoutSummary}
      {this.props.showModal ? null : checkoutForm}
    </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    ingredients: state.burger.ingredients,
    prices: state.burger.ingredientPrices,
    total: state.burger.totalPrice,
    nextOrderID: state.burger.nextOrderID,
    orders: state.orders.orders,
    showModal: state.global.showModal,
    token: state.auth.token,
    userId: state.auth.userId,
    redirectLocation: state.auth.redirectLocation
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    ResetOrder: () => dispatch(actionCreators.setBurgerData(null, null)),
    SubmitOrder: (formData, token, userId) => dispatch(actionCreators.submitOrder(formData, token, userId)),
    ToggleModal: () => dispatch(actionCreators.toggleModal()),
    GetOrders: (token, userId) => dispatch(actionCreators.getOrders(token, userId)),
    GetBurgerData: (token, userId) => dispatch(actionCreators.getBurgerData(token, userId)),
    SetServerBurgerData: (token, userId, ingredients) => dispatch(actionCreators.setServerBurgerData(token, userId, ingredients)),
    ClearPageError: () => dispatch(actionCreators.clearPageError()),
    SetLoginRedirect: (redirectLocation) => dispatch(actionCreators.setLoginRedirect(redirectLocation)),
    GetNextID: (token, userId) => dispatch(actionCreators.getNextID(token, userId)),
    Logout: () => dispatch(actionCreators.logout())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(Checkout, axios));




// WEBPACK FOOTER //
// ./src/containers/Checkout/Checkout.jsx